
















import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { fomatLocaletoArray } from "@root/lib/common";
import { ProductChildren } from "@root/lib/mixins";
const Root = namespace("root");

const productCreate = namespace("productCreate");
@Component({
  components: {}
})
export default class description extends Mixins(ProductChildren) {
  // articleId: any = "";
  tinymceHtml: any = "";
  tinymceId: number = 123;
  editor: any = null;
  // lang: string = "";
  // loading: boolean = false;
  @Prop({ default: false })
  isEdit!: boolean;
  @Prop({ default: false }) readonly;
  @productCreate.Getter propertiesData;
  @productCreate.Getter productDescription;
  @Root.State languageList;

  productDescriptionLocales = {};
  activeName = localStorage.getItem("Language");

  @Watch("productDescription")
  onProductDescriptionChange(val) {
    this.tinymceHtml = val.productDescription;
    let { productDescription } = val.extendParams;
    if (productDescription && productDescription["[AC]"]) {
      this.productDescriptionLocales = productDescription["[AC]"];
    }
    this.languageList.forEach((item, index) => {
      if (!this.productDescriptionLocales[item.value]) {
        this.$set(
          this.productDescriptionLocales,
          item.value,
          index === 0 ? val.productDescription : ""
        );
      }
    });
  }
  @productCreate.Action updateProduct;
  @productCreate.Action queryProductInfo;
  handleVaildate() {
    return new Promise((resolve, reject) => {
      let localeList =
        fomatLocaletoArray(
          this.languageList,
          this.productDescriptionLocales,
          "productDescription"
        ) || [];
      let res = {
        localeList,
        productDescription: this.tinymceHtml
      };
      resolve(res);
    });
  }
  handlePrev() {
    this.$emit("prev");
  }
  mounted() {
    // this.lang = this.$i18n.locale;
    try {
      this.tinymceHtml = this.productDescription;
    } catch (err) {
      console.log(err);
    }
  }
  // async getNewData() {
  //   let res = await this.queryProductInfo(this.propertiesData.productCode);
  // }
}
